export default "__VITE_ASSET__mcndTwKK__"